import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { IPage } from '../../../models/page';
import Title from '../../../components/UI/Title/Title';
import Filters from '../../../components/Container/Filters/Filters';
import TableButtons from '../../../components/UI/TableButtons/TableButtons';
import { FieldTypes, IFormFields } from '../../../models/form';
import { useAppSelector } from '../../../store';
import { IButton } from '../../../models/button';
import { ordersReportValidation } from '../../../utils/formValidation/ordersReport';
import { ReportsActions } from '../../../store/entities/reports/reports.actions';
import { GeneralActions } from '../../../store/entities/general/general.actions';
import { useEffect, useMemo } from 'react';
import { ISelectItem } from '../../../models/autoComplete';
import { IDynamicList } from '../../../store/entities/general/type';
import { CONSTANTS } from '../../../utils/constants';

import './OrdersReports.scss';

const OrdersReports = ({ permission, nextRoute }: IPage) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { formikProps } = useAppSelector((store) => store.form);
    const { appLanguage } = useAppSelector((state) => state.general);
  const { paymentStatuses } = useAppSelector((store) => store.general);
  const fromCreatedDate = formikProps?.values?.fromCreatedDate;
  const toCreatedDate = formikProps?.values?.toCreatedDate;
  const paymentStatus = formikProps?.values?.paymentStatus;

  useEffect(() => {
    dispatch(GeneralActions.getPaymentStatuses());
  }, [dispatch]);

  const paymentStatusSelect: ISelectItem[] = useMemo(
    () =>
      (paymentStatuses ?? []).map((item: IDynamicList) => ({
        key: String(item.id),
        value: appLanguage === CONSTANTS.DEFAULT_LANGUAGE ? item.nameHE : item.nameEN ?? '',
      })),
    [paymentStatuses, appLanguage]
  );

  const searchFields: IFormFields = {
    initialValues: {
      fromCreatedDate: null,
      toCreatedDate: null,
      paymentStatus: null,
    },
    formData: [
      {
        type: FieldTypes.DATE,
        id: 'fromCreatedDate',
        label: 'searchFields.fromCreatedDate',
        props: {
          getStartOfDay: true,
          showHours: true,
          defaultTime: new Date(0, 0, 0, 0, 0, 0),
        },
      },
      {
        type: FieldTypes.DATE,
        id: 'toCreatedDate',
        label: 'searchFields.toCreatedDate.label',
        props: {
          getFullDayTime: true,
          numOfDays: 1,
          minDate: new Date(fromCreatedDate),
          showHours: true,
          defaultTime: new Date(0, 0, 0, 23, 59, 59),
        },
      },
      {
        type: FieldTypes.SELECT,
        id: 'paymentStatus',
        label: 'searchFields.paymentStatus.label',
        items: paymentStatusSelect,
      },
    ]
  };

  const DownloadExcelOrdersReport = async () => {
    dispatch(
      ReportsActions.downloadOrdersReport(fromCreatedDate, toCreatedDate, paymentStatus ?? undefined)
    );
  };

  const tableButtons: IButton[] = [
    {
      title: 'button.exportCSV',
      show: true,
      onClick: () => DownloadExcelOrdersReport(),
      disabled:
        !fromCreatedDate || !toCreatedDate || fromCreatedDate > toCreatedDate,
    },
  ];

  return (
    <>
      <div className="manageOrdersReport__wrapper">
        <Title text="reports.ordersReport.pageTitle" />

        <Filters
          fields={searchFields}
          filtersValidation={ordersReportValidation}
          isExtended={false}
        />

        <TableButtons generalButtons={[]} tableButtons={tableButtons} />
      </div>
    </>
  );
};

export default OrdersReports;
